import { atom } from 'jotai';
export const $USPreBanState = atom(false);
$USPreBanState.debugLabel = '$USPreBanState';
